export default __webpack_public_path__ + "static/media/wordMap.52a10cd1.png";